export default "__VITE_ASSET__DVEHCL69__"